import React from 'react';
import { Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { CommonCellRendererWrapper, CommonHeaderRendererWrapper } from './styled';

export const CommonHeaderRenderer = ({ column }) => {
  const { title, tooltip } = column ?? {};

  return (
    <CommonHeaderRendererWrapper>
      <CommonCellRendererWrapper text={title} style={{ width: 'auto' }}>
        {title}
      </CommonCellRendererWrapper>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <ExclamationCircleOutlined
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        </Tooltip>
      ) : null}
    </CommonHeaderRendererWrapper>
  );
};
